import React, { useState } from 'react';
import {
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Hidden
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { home, appStoreLink, playStoreLink } from '../../routes/routes.json';

import AppConfig from "../../model/AppConfig";
import { useAppConfig } from "../../context/AppConfigContext";
import openInNewTab from '../../utils/common';

//import navbarTextImg from '../../assets/static/RecallsTextLogo.png';
import appLogo from '../../assets/static/FoodRecallsRoundedLogo.png';
import usFlagImg from '../../assets/static/icon-us-flag.png';
import caFlagImg from '../../assets/static/icon-ca-flag.png';
import playStoreImg from '../../assets/static/Play-Store.png';
import appStoreImg from '../../assets/static/App-Store.png';

const useStyle = makeStyles((theme) => ({
  appbar: {
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.complex,
    }),
    color: "transparent",
    backgroundColor: "white",
    elevation: 1
  },
  logoTitle: {
    [theme.breakpoints.only('xl')]: {
      fontSize: 26,
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 23,
    },
    [theme.breakpoints.only('xs')]: {
      fontSize: 20,
    },
  },
  logoNavbar: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
    marginLeft: 18,
  },
  menuButton: {
    // [theme.breakpoints.up('lg')]: {
    //   display: 'none',
    // },
    paddingRight: 5,
    color: "grey" //theme.palette.primary.main
  },
  linkTitile: {
    textDecoration: 'none',
    color: "black",
  },
  navbarLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: 'none',
  },
  navbarImg: {
    width: 30,
    height: 30,
    marginRight: 10,
    // [theme.breakpoints.down('lg')]: {
    //   width: 40,
    // },
    // [theme.breakpoints.only('xs')]: {
    //   width: 35,
    // },
    cursor: "pointer",
  },
  chevronIcon: {
    marginLeft: '8px',
    cursor: 'pointer',
  },
  navbarTexImg: {
    width: 140,
    height: 27,
    marginRight: 10,
    // [theme.breakpoints.down('lg')]: {
    //   width: 40,
    // },
    // [theme.breakpoints.only('xs')]: {
    //   width: 35,
    // },
  },
  mobileAppContainer: {
    display: window.isMobileApp ? "none" : "block",
    paddingLeft: 5,
    paddingRight: 5,
  },
  appStoreBanner : {
    height: 40,
    cursor: "pointer",
    paddingLeft: 5,
    paddingRight: 5,
  },
  dropdownMenu: {
    position: "absolute",
    top: "100%",
    left: 0,
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
    zIndex: theme.zIndex.modal,
    width: 150,
    padding: theme.spacing(0.5, 0),
  },
  dropdownItem: {
    display: "flex",
    alignItems: "center", // Align flag & text horizontally
    padding: "8px 12px",
    cursor: "pointer",
    whiteSpace: "nowrap", // Prevents text from wrapping
  },
  flagIcon: {
    width: "20px",
    height: "20px",
    marginRight: "8px", // Space between flag & label
    display: "inline-block",
  },
  dropdownLabel: {
    fontSize: "16px",
    color: "#000", // Ensure visible text
    flexGrow: 1, // Ensures text doesn't disappear
  },
}));

const handleAppStoreClick = (e) => {
  e.preventDefault();

  openInNewTab(appStoreLink);
}

const handlePlayStoreClick = (e) => {
  e.preventDefault();

  openInNewTab(playStoreLink);
}

const Navbar = (props) => {
  const classes = useStyle();
  const { appConfigDict, setAppConfigDict } = useAppConfig();
  const { country } = appConfigDict;
  const [showDropdown, setShowDropdown] = useState(false);

  // Map country code to navbar image
  let navbarImg = AppConfig.getFlagImg(country);
  navbarImg = appLogo;

  const setCountry = (newCountry) => {
    console.log(`Setting country to ${newCountry}`)
    setAppConfigDict((prev) => ({ ...prev, country: newCountry }));
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  return (
    <>
      {/* <ElevationScroll> */}
        <AppBar position="fixed" className={classes.appbar}>
          <Toolbar>
            <div className={classes.logoNavbar}>
              <Link to={home} className={classes.navbarLink}>
                <img
                  src={navbarImg}
                  alt="Logo"
                  className={classes.navbarImg}
                  // onClick={toggleDropdown} // Toggle dropdown on click
                />
              </Link>

              {/* Dropdown Menu */}
              {showDropdown && (
                <div className={classes.dropdownMenu}>
                  <div className={classes.dropdownItem} onClick={() => setCountry("us")}>
                    <img src={usFlagImg} alt="US Flag" className={classes.flagIcon} />
                    <span className={classes.dropdownLabel}>US</span>
                  </div>
                  <div className={classes.dropdownItem} onClick={() => setCountry("ca")}>
                    <img src={caFlagImg} alt="Canada Flag" className={classes.flagIcon} />
                    <span className={classes.dropdownLabel}>Canada</span>
                  </div>
                </div>
              )}

              <Typography
                variant="h1"
                color="secondary"
                className={classes.logoTitle}
              >
                <Link to={home} className={classes.linkTitile}>
                  FoodRecalls
                </Link>
              </Typography>
            </div>
            <Hidden xsDown>
              <div className={classes.mobileAppContainer}>
                <img src={appStoreImg} alt="AppStore" className={classes.appStoreBanner} onClick={handleAppStoreClick} />
                <img src={playStoreImg} alt="PlayStore" className={classes.appStoreBanner} onClick={handlePlayStoreClick} />
              </div>
            </Hidden>
            <IconButton
              edge="start"
              className={classes.menuButton}
              aria-label="menu"
              size="medium"
              onClick={() => props.toggleOpen()}
            >
              <Menu />
            </IconButton>
          </Toolbar>
        </AppBar>
      {/* </ElevationScroll> */}
    </>
  );
};

export default Navbar;
